import * as React from 'react';

import type {CoreEntityType} from 'nutshell-core/types';

import type {Flow} from 'flow-to-typescript-codemod';

import {ActionsDefault} from './actions-default';
import type {Props as ActionsDefaultOwnProps} from './actions-default';
import {AdTechFXButton} from './adtech-fx-button';
import {BulkSyncButton} from './bulk-sync-button';

type ActionsDefaultProps = Flow.Diff<
    ActionsDefaultOwnProps,
    {
        entityType: CoreEntityType;
    }
>;

type Props = ActionsDefaultProps & {
    handleSyncToWebfxSubmit: (arg1: 'contacts' | 'leads') => (...args: any) => any;
    selectedCount: number;
};

export function ActionsLead(props: Props) {
    const {handleSyncToWebfxSubmit, ...restProps} = props;

    return (
        <>
            {NutClientConfig.hasAdTechFxUpsell && <AdTechFXButton />}
            {NutClientConfig.hasSyncLeadsButton && (
                <BulkSyncButton
                    selectedCount={props.selectedCount}
                    onSubmit={handleSyncToWebfxSubmit('leads')}
                    entityType={'leads'}
                />
            )}
            <ActionsDefault entityType={'leads'} {...restProps} />
        </>
    );
}
